import { Grid } from '@mui/material';

import CustomCard from '../../components/CustomCard';
import { PROJECTS } from '../../constants/projects';
import ProjectCard from '../../components/ProjectCard';
import projectsIcon from '../../assets/icons/projects.png';
import useVisibilityOnScroll, { animationStyle, visibleStyle } from '../../hooks/useVisibilityOnScroll';

const Projects = () => {
  const [projectsRef, isProjectsVisible] = useVisibilityOnScroll(0.2);
  const staggerDelay = 300;

  return (
    <CustomCard title="Projects" titleIcon={projectsIcon} boxStyle={{ py: 0}}>
      <Grid ref={projectsRef} container spacing={2} my={2}>
        {
          PROJECTS.map((project, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }}
              key={index}
              sx={{
                display: 'flex',
                ...animationStyle,
                ...(isProjectsVisible && {
                  ...visibleStyle,
                  transitionDelay: `${index * staggerDelay}ms`,
                }),
              }}
            >
              <ProjectCard
                title={project.title}
                description={project.description}
                technologies={project.technologies}
              />
            </Grid>
          ))
        }
      </Grid>
    </CustomCard>
  )
}

export default Projects;